import { day6Analytics } from '@/util/analyticsUtil'

const mixin = {
  data: function () {
    return {
      // Share counter for analytics
      analyticsShareCount: 0
    }
  },
  methods: {
    /**
     * Updates share state and captures analytics if opening from share link
     */
    analyzeShareRoute () {
      const { query } = this.$route
      if (query) {
        this.analyticsShareCount = (query.sc ? parseInt(query.sc) : 0) + 1
        day6Analytics.shareOpen(this.analyticsShareCount)
      }
    },
    captureOpenAccount (isOpeningPay) {
      day6Analytics.onOpenAccount(this.isAuthenticated, isOpeningPay)
    }
  }
}

export default mixin
